const React = require('react');
const { StoreProvider } = require('./src/context/StoreContext');

exports.wrapRootElement = ({ element }) => (
  <StoreProvider>{element}</StoreProvider>
);
